import request from '@/utils/request'

let LineApi = {

  /*线路列表*/
  list(data) {
    return request._post('/shop/plus.line.Index/index', data);
},
/*添加线路*/
add(data) {
    return request._post('/shop/plus.line.Index/add', data);
},
/*修改线路*/
edit(data) {
    return request._post('/shop/plus.line.Index/edit', data);
},
/*删除线路*/
del(data) {
    return request._post('/shop/plus.line.Index/del', data);
},
/*线路详情*/
detail(data) {
  return request._post('/shop/plus.line.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.line.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.line.Setting/getSetting', data, errorback);
    },
}
export default LineApi;



// WEBPACK FOOTER //
// ./src/api/line.js